import {needAuth} from "../../instance/Instance";
import {apiRequest} from "../../../components/Utils/SimmsUtils";
import {getParam} from "../../../components/Utils/Utils";
import {AxiosError} from "axios";

const getRequestRentalsForRentalAsset = async (data, success) => {
    return apiRequest(
        () => needAuth.get(`/rentalRequest/rentalAssets/${data.rentalAssetId}?${getParam(data.pageable)}`),
        success
    );
}
const getRequestRentalAdminList = async (search, pageable) => {
    try {
        return needAuth.post(`/rentalRequest/admin?${getParam(pageable)}`, search);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const getRequestRentalUserList = async (search, pageable) => {
    try {
        return needAuth.post(`/rentalRequest/user?${getParam(pageable)}`, search);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const getRequestRental = async (rentalRequestId, success) => {
    return apiRequest(() => needAuth.get(`/rentalRequest/${rentalRequestId}`), success);
}

const getRequestRentalWithRentalAsset = async (rentalRequestId, success) => {
    return apiRequest(() => needAuth.get(`/rentalRequest/${rentalRequestId}/rentalAsset`), success);
}

const createRentalRequest = async (data, success) => {
    return apiRequest(() => needAuth.post(`/rentalRequest/create`, data), success);
}

const approveRentalRequest = async (data, success, failToApprove) => {
    return apiRequest(() => needAuth.post(`/rentalRequest/approve`, data), success, failToApprove);
}

const extendRentalRequest = async (data, success, failToExtend) => {
    return apiRequest(() => needAuth.put(`/rentalRequest/extend`, data), success, failToExtend);
}

const returnRentalRequest = async (data, success, failToReturn) => {
    return apiRequest(() => needAuth.put(`/rentalRequest/return`, data), success, failToReturn);
}

const rejectRentalRequest = async (data, success, failToReject) => {
    return apiRequest(() => needAuth.put(`/rentalRequest/reject`, data), success, failToReject);
}

const requestRentalRequest = async (data, success) => {
    return apiRequest(() => needAuth.post(`/rentalRequest/request`, data), success);
}

const removeRentalRequest = async (data, success) => {
    return apiRequest(() => needAuth.put(`/rentalRequest/remove`, data), success);
}

const cancelRentalRequest = async (data, success, failure) => {
    // 대여신청 취소 실패시 -> 이미 관리자가 `대여중`, `대여거절` 로 rentalType 을 변경했을때
    return apiRequest(() => needAuth.put(`/rentalRequest/cancel`, data), success, failure);
}

const getRentalTypes = async (success) => {
    return apiRequest(() => needAuth.get(`/rentalRequest/rentalTypes`), success);
}

export {
    createRentalRequest, getRequestRental,
    extendRentalRequest, returnRentalRequest,
    getRequestRentalsForRentalAsset, getRequestRentalAdminList,
    rejectRentalRequest, getRequestRentalWithRentalAsset, getRequestRentalUserList,
    requestRentalRequest, approveRentalRequest, removeRentalRequest,
    cancelRentalRequest, getRentalTypes
}
